import http from '@services/http'
import { IReportCreate } from '@protocol/report'

export default {
  createReport(data: IReportCreate.Params): Promise<IReportCreate.Schema> {
    return http.post('report/create', data || {})
  },
}
